import { SpaceIOService, UserService } from "auth-utils";
import config from "./index";

const bootstrap = () => {
	const spaceIOService = new SpaceIOService({
		newAuthTokenBufferTimeInSeconds: 30,
		accountWsUrl: config.REACT_APP_PRODWS_AFREESPACE_URL,
		loginUrl: config.REACT_APP_LOGIN_API_URL,
	});
	const userService = new UserService({ spaceIOService });

	return {
		spaceIOService,
		userService,
	};
};

export default bootstrap;
